<template>
  <div class="HomePage">
    <!-- <div id="app">
              <h1>{{ $t("message.hello") }}</h1>
              <button @click="changeLanguage('zh')">中文</button>
              <button @click="changeLanguage('ja')">日本語</button>
            </div> -->
    <div class="con_box">
      <div class="top_box">
        <div class="top_img" @click="toHome">
          <img src="../assets/logo.jpg" alt="" @click="toHome" />
        </div>
        <div class="top_rig">
          <div @click="toGaiyao" class="tab">{{ $t("home.h2") }}</div>
          <div @click="tojieshao" class="tab">{{ $t("home.h3") }}</div>
          <div @click="toshiji" class="tab">{{ $t("home.h4") }}</div>
          <div class="tab tab1">{{ $t("home.h5") }}</div>
          <!-- <select v-model="selectedOption" @change="handleChange">
            <option disabled value="">请选择</option>
            <option>中文</option>
            <option>日本語</option>
          </select> -->
        </div>
      </div>
      <div class="bg_img">
        <img src="../assets/bg.png" alt="" />
      </div>

      <div class="hudong_title">お問い合わせ</div>
      <div class="img_w1">
        <img src="../assets/w1.png" alt="" />
      </div>
      <div class="title2">
        担当者より折り返しのお電話またはメールをさせていただきます。
      </div>
      <!-- <div class="d1">メ-ルのお間い合わせ</div>
      <div class="d2">jcieea_info@yeah.net</div>
      <div class="d3">
        担当者より折り返しのお電話またはメ-ルをさせていただきます。
      </div> -->
      <div class="d_img">
        <img src="../assets/03.jpg" alt="" />
      </div>
      <div class="footer">
        <div class="foo_con">
          <div class="fo_le">
            <img src="../assets/logo2.png" alt="" />
            <div class="fo_le_re">
              <div class="fo_top">{{ $t("home.h23") }}</div>
              <div class="fo_le_re_bo">
                <div @click="goToTop">{{ $t("home.h24") }}</div>
                <div @click="toGaiyao">{{ $t("home.h25") }}</div>
                <div @click="tojieshao">{{ $t("home.h26") }}</div>
                <div @click="toshiji">{{ $t("home.h27") }}</div>
              </div>
            </div>
          </div>
          <div class="fo_re">{{ $t("home.h28") }}</div>
        </div>
        <div class="beian">{{ $t("home.h29") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  props: {
    msg: String,
  },
  data() {
    return {
      value1: 0,
      option1: [
        { text: "中文", value: 0 },
        { text: "日本語", value: 1 },
      ],
      selectedOption: "日本語",
    };
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    handleChange(event) {
      if (event.target.value == "日本語") {
        this.$i18n.locale = "ja";
      } else if (event.target.value == "中文") {
        this.$i18n.locale = "zh";
      }
    },
    toHome() {
      this.$router.push({ name: "HomePage" });
    },
    toGaiyao() {
      this.$router.push({ name: "GaiYao" });
    },
    tojieshao() {
      this.$router.push({ name: "JieShao" });
    },
    toshiji() {
      this.$router.push({ name: "ShiJi" });
    },
    towenxun() {
      this.$router.push({ name: "WenXun" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 700px) {
  .con_box,
  .top_box,
  .im_list,
  .foo_con,
  .top_img {
    width: 100% !important;
  }
  .top_img img {
    width: 100% !important;
  }
  .top_box,
  .img_box,
  .fo_le,
  .foo_con {
    flex-wrap: wrap;
    margin-bottom: 20px !important;
  }
  .fo_le {
    justify-content: center;
  }
  .HomePage {
    padding: 0 !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .hudong_title {
    width: 40% !important;
    font-size: 16px !important;
    height: 40px !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
    font-size: 14px;
    margin: 0 auto;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .footer {
    padding-top: 0 !important;
  }
  .fo_le img {
    width: 100px !important;
    height: 100px !important;
  }
  .foo_con {
    flex-direction: column !important;
  }
  .fo_le {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0 !important;
  }
  .fo_le_re_bo {
    margin-top: 20px !important;
  }
  .beian {
    margin-top: 0 !important;
  }
  .biao {
    width: 100% !important;
  }
  .d1 {
    margin-top: 0 !important;
    margin-bottom: 20px !important;
  }
  .d3 {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .d_img {
    width: 100% !important;
    margin-bottom: 40px !important;
  }
  .title2 {
    margin-top: -65px !important;
    font-size: 12px !important;
    margin-bottom: 41px !important;
  }
  .img_w1 {
    margin-top: -28px !important;
  }
}
.title2 {
  text-align: center;
  margin-top: -316px;
  font-size: 20px;
  margin-bottom: 85px;
}
.img_w1 {
  width: 100%;
}
.img_w1 img {
  width: 100%;
}
.d_img {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 117px;
}
.d_img img {
  width: 100%;
}
.d1 {
  width: 70%;
  margin: 0 auto;
  margin-top: 200px;
  margin-bottom: 50px;
  text-align: left;
  font-size: 20px;
  font-weight: 600;
}
.d2 {
  width: 70%;
  margin: 0 auto;
  text-align: left;
}
.d3 {
  width: 70%;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 200px;
  text-align: left;
}
/* css */
.HomePage {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.con_box {
  width: 90%;
  margin: 0 auto;
}
.top_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_img {
  display: flex;
  gap: 0px;
  align-items: center;
}

.name_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
}
.name_box :nth-child(1) {
  font-size: 22px;
  font-weight: 600;
}
.hudong_title {
  width: 25%;
  height: 60px;
  font-size: 27px;
  border-radius: 30px;
  background-color: #1e386b;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.top_rig {
  display: flex;
  gap: 20px;
  align-items: center;
}
.tab1 {
  color: #1e386b;
  font-size: 20px;
  font-weight: 600;
}
.HomePage >>> .van-dropdown-menu__bar {
  width: 115px;
  height: 40px;
  /* box-shadow: none; */
}
.HomePage >>> .van-dropdown-item__content {
  /* right: 222px !important; */
  width: 116px;
}
.HomePage >>> .van-popup--top {
  right: 222px !important;
  left: auto;
}
.van-popup--top {
  right: 222px;
  left: auto;
}
.tab {
  cursor: pointer;
}
.footer {
  background-color: #153266;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.foo_con {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}
.fo_le {
  display: flex;
  gap: 40px;
}
.fo_le img {
  width: 200px;
  height: 200px;
}
.fo_le_re {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
}
.fo_top {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}
.fo_le_re_bo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
}
.fo_re {
  color: #fff;
  cursor: pointer;
}
.beian {
  text-align: center;
  margin-top: 70px;
  /* margin-bottom: 10px; */
  color: #fff;
}
select {
  width: 100px;
  height: 40px;
  box-shadow: 1px 2px 3px #999;
  border: none;
  text-align: center;
  outline: none;
}
.bg_img {
  width: 100%;
}
.bg_img img {
  width: 100%;
}
.fo_le_re_bo div {
  cursor: pointer;
}
</style>
